module.exports = __webpack_public_path__ + "img/singup4.c591f75b.jpg";